import "./CertificateGroupingWIthRatingReview.scss";
import CertificateWithRatingReview from "../../features/ServiceCertificateGrouping/PeerReviewFormCertificate/CertificateWithRating/CertificateWithRatingReview";

const CertificateGroupingWIthRatingReview = () => {
  return (
    <div className="analytics-page">
       <CertificateWithRatingReview/> 
    </div>
  );
};

export default CertificateGroupingWIthRatingReview;
